import React from 'react';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { HelpLink } from './HelpLink';
export const HelpLinkList = ({ title, links }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { component: "div", sx: {
                borderBottom: '1px solid #d1d1d1',
            } },
            React.createElement(Box, { fontSize: "h6.fontSize", fontWeight: "fontWeightBold", lineHeight: 1.5, paddingBottom: 2 }, title)),
        links.map((link) => (React.createElement(HelpLink, { link: link, key: link.label })))));
};
